import React from 'react';
import { Route, Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from 'context/auth-context';
import cookies from 'utils/cookies';
import { useUser } from 'hooks/shared/auth.hooks';

const PrivateRoute = ({ children }) => {
	const { authenticated, setUser, setAuthenticated } = useAuth();
	const [params] = useSearchParams();

	if (params.get('refresh_token') || params.get('access_token')) {
		cookies.setAccessToken(params.get('access_token'));
		cookies.setRefreshToken(params.get('refresh_token'));
	}

	// Fetch authenticated user query.
	// Order here is important. Always check for the params first as new logins will have a params. Cookies are for existing users.
	const {
		data: user_data,
		isLoading,
		error,
	} = useUser({
		enabled: authenticated,
		refresh_token: params.get('refresh_token') || cookies.getRefreshToken(),
	});

	if (user_data) {
		setUser(user_data);
		setAuthenticated(true);
	}
	if (isLoading) {
		return <div>Loading...</div>;
	}
	if (error) {
		return <Navigate to="/signin" />;
	}

	return (
		// Show the component only when the user is logged in
		// Otherwise, redirect the user to /signin page
		user_data ? children : <Navigate to="/signin" />
	);
};

export default PrivateRoute;
